'use client'

import React, { useState } from 'react'
import { cn } from '@/utilities/ui'

/**
 * Client island: tab switching logic for Feature6.
 * Only this file ships JS to the browser.
 * All tab content is pre-rendered on the server and passed as ReactNode.
 */

type TabItem = {
  id: string
  buttonContent: React.ReactNode
  panelContent: React.ReactNode
}

export const Feature6Tabs: React.FC<{ tabs: TabItem[] }> = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0)

  if (tabs.length === 0) return null

  return (
    <div>
      {/* Tab buttons */}
      <div className="flex h-auto w-full flex-col gap-2 bg-background md:flex-row">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(index)}
            className={cn(
              'flex w-full flex-col items-center justify-center gap-3 rounded-2xl border px-6 py-5 text-center whitespace-normal text-primary hover:border-primary/40 transition-colors',
              activeTab === index ? 'border-primary' : 'border-border',
            )}
          >
            {tab.buttonContent}
          </button>
        ))}
      </div>

      {/* Active tab panel */}
      <div className="mt-6 width-full">{tabs[activeTab]?.panelContent}</div>
    </div>
  )
}
